import { API } from '../../utils';
import { GW_SERVICES_PREFIXES } from '../../constants';
import { AIRequestCreateDTO } from './types';
import { IRequest } from '../../types';

const { REQUEST, C300 } = GW_SERVICES_PREFIXES;

/* Создание заявки сотрудником при помощи ИИ */
export const CreateAiRequest = (data: AIRequestCreateDTO) =>
  API.gatewayPost(`/${REQUEST}/request/employee/ai/create_ai_request/`, data);

/* Получение всех активных AI-задач сотрудника */
export const GetAiTasks = () =>
  API.get(`/${REQUEST}/request/employee/ai/tasks/get_active_tasks/`);

/* Отмена задачи ИИ */
export const CancelAiTask = (taskId: string) =>
  API.gatewayPatch(
    `/${REQUEST}/request/employee/ai/tasks/cancel_task/${taskId}/`
    // taskId
  );

/* Создание обычной заявки на основе АИ-модели */
export const CreateModeratedAiRequest = (
  requestNumber: string,
  data: IRequest
) =>
  API.gatewayPatch(
    `/${REQUEST}/request/employee/ai/moderated_ai_request/`,
    requestNumber,
    data
  );

export const RecordPoint = (body: { call_id: string; record_point: number }) =>
  API.gatewayPost(`/${C300}/form/processing_call/record_point/`, body);
